import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=7c973f08&scoped=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleSection.vue?vue&type=style&index=0&id=7c973f08&prod&lang=scss&scoped=true"
import style1 from "./CollapsibleSection.vue?vue&type=style&index=1&id=7c973f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c973f08",
  null
  
)

export default component.exports